import { ITeam } from '@/types/team';
import { format, isValid } from 'date-fns';
import { MRT_ColumnDef } from 'material-react-table';
import { InvitationInTheTable } from './ListInvitationsTable.types';

export function getListInvitationsTableColumns(): MRT_ColumnDef<InvitationInTheTable>[] {
  const columns: MRT_ColumnDef<InvitationInTheTable>[] = [];

  columns.push({
    accessorKey: 'email',
    header: 'Email',
    Cell: ({ row }) => (
      <div className="flex items-center">
        <span className="text-sm">{row.original.email}</span>
      </div>
    ),
  });

  columns.push({
    accessorKey: 'role',
    header: 'Role',
    Cell: ({ row }) => (
      <div className="flex items-center justify-center">
        <span className="text-sm">{row.original.role || '—'}</span>
      </div>
    ),
  });

  columns.push({
    accessorKey: 'team',
    header: 'Team',
    Cell: ({ row }) => (
      <div className="flex items-center justify-center">
        <span className="text-sm">
          {row.original.team ? (row.original.team as ITeam).name : '—'}
        </span>
      </div>
    ),
  });

  columns.push({
    accessorKey: 'expiresAt',
    header: 'Expires At',
    Cell: ({ row }) => (
      <div className="flex items-center justify-end">
        <span className="text-sm">
          {isValid(new Date(row.original.expiresAt))
            ? format(row.original.expiresAt, 'Pp')
            : '—'}
        </span>
      </div>
    ),
  });

  return columns;
}
